// import Raven from 'raven-js'

export const loggingMiddleware = store => next => action => {
  if (process.env.NODE_ENV === 'production') {
    return next(action)
  }
  console.group && console.group(action.type)
  console.info('dispatching', action)
  let result = next(action)
  console.log('next state', store.getState())
  console.groupEnd && console.groupEnd(action.type)
  return result
}

export const errorMiddleware = store => next => action => {
  try {
    return next(action)
  } catch (err) {
    console.error('Caught an exception!', err)
    // Raven.captureException(err, {
    //   extra: {
    //     action,
    //     state: store.getState()
    //   }
    // })
    throw err
  }
}



// WEBPACK FOOTER //
// ./app/lib/loggingMiddleware.js